import React from 'react'
import type { Icon } from 'shared/utils'

const CircleFish = (props: Icon) => {
    const {
        color = 'white',
        background = '#A11A2C',
        size = 32,
        className = 'circle-bacon'
    } = props
    return (
        <svg width={size} height={size} className={className}>
            <g fill="none" fillRule="evenodd">
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={size / 2}
                    fill={background}
                />
                <path
                    fill={color}
                    d="M25.188 6.644c.064.178 1.503 4.308-1.407 8.3.699.904.866 1.861.468 2.722-.832 1.8-5.1 4.008-5.583 4.255a.414.414 0 0 1-.378-.003.404.404 0 0 1-.214-.308l-.283-2.243a27.035 27.035 0 0 1-4.126 1.34l-2.015 4.465a.407.407 0 0 1-.372.24.41.41 0 0 1-.336-.175c-.053-.075-1.186-1.723-1.177-3.556h-.022c-1.844 0-3.498-1.119-3.567-1.167a.404.404 0 0 1 .065-.701l4.507-1.996c.37-1.493.824-2.865 1.352-4.09l-2.265-.28a.408.408 0 0 1-.31-.212.4.4 0 0 1-.002-.373c.249-.48 2.478-4.709 4.294-5.533.865-.392 1.835-.227 2.748.465A9.613 9.613 0 0 1 22.182 6c1.611 0 2.713.383 2.76.4.114.04.206.13.246.244zm-2.13 3.18c0-.811-.659-1.471-1.47-1.471-.81 0-1.47.66-1.47 1.47 0 .812.66 1.471 1.47 1.471.811 0 1.47-.66 1.47-1.47zm-1.47.66a.661.661 0 1 1 .002-1.323.661.661 0 0 1-.002 1.323z"
                />
            </g>
        </svg>
    )
}

export { CircleFish }
